import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BalanceSubjectService {
  constructor() {}
  balanceData: BehaviorSubject<any> = new BehaviorSubject('');

  handleBalanceData(val: boolean) {
    this.balanceData.next(val);
  }
}
